import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/api";

export default function VerifyEmail() {
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setStatus("error");
      setError("No confirmation token found in this link.");
      return;
    }

    api.get(`/user/verify-email?token=${encodeURIComponent(token)}`)
      .then((res) => {
        if (res.data?.accessToken) {
          localStorage.setItem("accessToken", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          if (res.data.user) {
            localStorage.setItem("user", JSON.stringify(res.data.user));
          }
          sessionStorage.setItem("pp_just_logged_in", "1");
        }
        setStatus("success");
        // Brief pause so the success state is visible before the redirect
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 1200);
      })
      .catch((err) => {
        setStatus("error");
        setError(err.response?.data?.message || "Please request a new confirmation email.");
      });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="w-full max-w-[380px] text-center">
        {status === "loading" && (
          <>
            <div className="w-9 h-9 border-2 border-purple-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Confirming your account…</h1>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Just a moment.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="w-12 h-12 bg-green-50 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Email confirmed! 🎉</h1>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Taking you to your dashboard…</p>
          </>
        )}

        {status === "error" && (
          <>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Link invalid or expired</h1>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 mb-6">{error}</p>
            <Link to="/login" className="inline-block bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium px-6 py-2.5 rounded-md transition">
              Go to Sign In
            </Link>
          </>
        )}
      </div>
    </div>
  );
}